import React from 'react';
import { Button, Container, Message } from '@hvcgroep/design-system';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { AUTH_URL, LOG_IN_PAGE_MESSAGE, DISABLE_AUTH } from '../../config/constants';
import { ReactComponent as LogoTruncated } from '../../assets/images/logo-truncated.svg';

import './style.scss';

// @TODO: Awaiting design

const LogIn: React.FC = () => {
  const { t } = useTranslation();
  const heading = t('pages.logIn.title');
  const siteTitle = t('general.siteTitle');

  return (
    <Container fluid>
      <Helmet><title>{`${heading} - ${siteTitle}`}</title></Helmet>
      <section className="d-flex mo-logIn">
        {LOG_IN_PAGE_MESSAGE && (
          <Message type="warning">{LOG_IN_PAGE_MESSAGE}</Message>
        )}
        <div>
          <LogoTruncated />
        </div>
        <div>
          <h1>{t('pages.logIn.title')}</h1>
          <p>{t('pages.logIn.logInDescription')}</p>
        </div>
        {/* dont show button when log in message is shown - disable login - for servermigration 9 dec */}
        {!DISABLE_AUTH && (
          <Button variation="center" href={AUTH_URL} aria-label={t('pages.logIn.toLoginPage')}>
            {t('pages.logIn.toLoginPage')}
          </Button>
        )}
      </section>
    </Container>
  );
};

export default LogIn;
